import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "widget-blog" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = {
  key: 0,
  id: "carouselExampleControls",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_5 = { class: "carousel-inner" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-3" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-lg-9" }
const _hoisted_10 = { class: "blog-content" }
const _hoisted_11 = { class: "pt-5 blog-title" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "float-end" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book-medical",
  style: {"color":"#3f4254"}
}, null, -1)
const _hoisted_16 = {
  class: "carousel-control-prev",
  type: "button",
  "data-bs-target": "#carouselExampleControls",
  "data-bs-slide": "prev"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/wizard/carousel-control-prev-icon.svg",
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "visually-hidden" }
const _hoisted_19 = {
  class: "carousel-control-next",
  type: "button",
  "data-bs-target": "#carouselExampleControls",
  "data-bs-slide": "next"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/wizard/carousel-control-next-icon.svg",
    alt: ""
  })
], -1)
const _hoisted_21 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBloader = _resolveComponent("MBloader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card mx-4 my-10"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MBloader, { MedicalRecordsTableLoaded: _ctx.isLoaded }, null, 8, ["MedicalRecordsTableLoaded"]),
          (_ctx.isLoaded && _ctx.hasData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogss, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["carousel-item", { active: index === '0' }]),
                      key: index,
                      style: {"padding":"8px"}
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: item.media.replace('-150x150', ''),
                              style: {"width":"192px","max-height":"160px"},
                              class: "rounded-3"
                            }, null, 8, _hoisted_8)
                          ])
                        ], 512), [
                          [_vShow, !_ctx.ismobile]
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                            _withDirectives(_createElementVNode("div", {
                              innerHTML: item.description,
                              class: "mt-4 blog-description"
                            }, null, 8, _hoisted_12), [
                              [_vShow, item.description.length > 0]
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("a", {
                                class: "btn btn-light",
                                href: item.link,
                                target: "_blank",
                                style: {"color":"#3f4254"}
                              }, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("Read More")), 1)
                              ], 8, _hoisted_14)
                            ])
                          ])
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("button", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Previous")), 1)
                ]),
                _createElementVNode("button", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("Next")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}